export default {
  // Navigation
  nav_home: "หน้าแรก",
  nav_products: "ผลิตภัณฑ์",
  nav_about: "เกี่ยวกับเรา",
  nav_support: "การสนับสนุน",
  nav_contact: "ติดต่อ",

  // Hero Section
  hero_title: "เครื่องดนตรีไทซาน",
  hero_subtitle: "เครื่องดนตรีพรีเมียมจากจีน",
  hero_description: "มุ่งมั่นในการผลิตเครื่องดนตรีทองเหลืองคุณภาพสูงตั้งแต่ปี 1987",
  hero_cta: "สำรวจผลิตภัณฑ์",

  // Products Section
  products_title: "ผลิตภัณฑ์ของเรา",
  products_subtitle: "เครื่องดนตรีทองเหลืองมืออาชีพ สร้างสรรค์ด้วยความเป็นเลิศ",
  product_trumpet: "ซีรีส์ทรัมเป็ต",
  product_trumpet_desc: "เครื่องดนตรีทองเหลืองมืออาชีพที่มีเสียงสดใสและเต็ม เหมาะสำหรับทุกโอกาสการแสดง",
  product_trombone: "ซีรีส์ทรอมโบน",
  product_trombone_desc: "การเลื่อนที่ราบรื่น ช่วงกว้าง เป็นที่ชื่นชอบของวงออเคสตราระดับมืออาชีพ",
  product_saxophone: "ซีรีส์แซกโซโฟน",
  product_saxophone_desc: "เสียงที่อุดมสมบูรณ์และนุ่มนวล เหมาะสำหรับดนตรีแจ๊สและคลาสสิก",
  product_horn: "ซีรีส์เฟรนช์ฮอร์น",
  product_horn_desc: "เสียงที่นุ่มนวลและอบอุ่น จำเป็นสำหรับวงออเคสตราซิมโฟนี",
  product_clarinet: "ซีรีส์คลาริเน็ต",
  product_clarinet_desc: "เครื่องดนตรีเป่าไม้คลาสสิกที่มีเสียงใสและน่าหลงใหล",
  product_flute: "ซีรีส์ฟลุต",
  product_flute_desc: "เสียงที่คมชัดและไพเราะ เหมาะสำหรับการแสดงเดี่ยวและวงดนตรี",
  view_details: "ดูรายละเอียด",

  // Product Catalog
  catalog_title: "ดาวน์โหลดแคตตาล็อกสินค้า",
  catalog_description: "ดาวน์โหลดแคตตาล็อก Taishan Instruments ฉบับสมบูรณ์สำหรับข้อมูลจำเพาะผลิตภัณฑ์โดยละเอียด",
  catalog_download: "ดาวน์โหลดแคตตาล็อก",

  // About Section
  about_title: "เกี่ยวกับเรา",
  about_subtitle: "มรดกฝีมือกว่า 30 ปี",
  about_heading: "เกี่ยวกับเครื่องดนตรีไทซาน",
  about_p1: "บริษัท Shandong Taishan Brass Instrument Manufacturing Co., Ltd. ก่อตั้งขึ้นในปี 1987 และเป็นผู้ผลิตเครื่องดนตรีทองเหลืองมืออาชีพชั้นนำในจีน ตั้งอยู่ในมณฑลซานตง บริษัทมีฐานการผลิตที่ทันสมัยและทีม R&D มืออาชีพ",
  about_p2: "ในปี 2004 ผลิตภัณฑ์ของบริษัทได้รับการทดสอบโดยศูนย์กำกับดูแลและตรวจสอบคุณภาพเครื่องดนตรีของกระทรวงวัฒนธรรมและทั้งหมดเป็นไปตามมาตรฐานแห่งชาติ ในปี 2006 บริษัทได้กลายเป็นหน่วยตรวจสอบโดยตรงและได้รับรางวัล 'องค์กรที่แข็งแกร่งในอุตสาหกรรมเครื่องดนตรีของจีน'",
  about_p3: "บริษัทได้ผ่านการรับรองระบบคุณภาพ ISO9001 และการรับรองระบบสิ่งแวดล้อม ISO14001 ผลิตภัณฑ์ถูกส่งออกไปยังหลายประเทศและภูมิภาคทั่วโลกและได้รับความไว้วางใจจากผู้รักดนตรีและนักแสดงมืออาชีพ",
  about_year: "ก่อตั้ง",
  about_series: "ซีรีส์ผลิตภัณฑ์",

  // Timeline
  timeline_title: "เส้นทางของเรา",
  timeline_1987: "บริษัทก่อตั้งขึ้น มุ่งเน้นการผลิตเครื่องดนตรีทองเหลือง",
  timeline_2001: "กลายเป็นสมาชิกของนิทรรศการเครื่องดนตรีนานาชาติจีน",
  timeline_2004: "ผลิตภัณฑ์ผ่านการตรวจสอบโดยศูนย์กำกับดูแลคุณภาพเครื่องดนตรีของกระทรวงวัฒนธรรม เป็นไปตามมาตรฐานแห่งชาติ",
  timeline_2006: "ได้รับรางวัล 'องค์กรที่แข็งแกร่งในอุตสาหกรรมเครื่องดนตรีของจีน'",
  timeline_2013: "เครื่องดนตรีทองเหลืองไทซานกลายเป็นแบรนด์จีนที่แข่งขันกับแบรนด์ระดับนานาชาติที่มีชื่อเสียง",
  timeline_2019: "ได้รับรางวัล 'SME เฉพาะทาง ประณีต โดดเด่น และนวัตกรรม' จากกรมวิทยาศาสตร์และเทคโนโลยีมณฑลซานตง",

  // Support Section
  support_title: "การสนับสนุนและบริการ",
  support_subtitle: "ระบบบริการหลังการขายมืออาชีพ",
  support_quality: "การรับประกันคุณภาพ",
  support_quality_desc: "ได้รับการรับรอง ISO9001 ทุกผลิตภัณฑ์ผ่านการทดสอบอย่างเข้มงวด",
  support_service: "บริการหลังการขาย",
  support_service_desc: "ทีมหลังการขายมืออาชีพให้บริการซ่อมบำรุงและให้คำปรึกษา",
  support_maintenance: "การซ่อมแซมและบำรุงรักษา",
  support_maintenance_desc: "บริการซ่อมแซมและบำรุงรักษาเครื่องดนตรีมืออาชีพ",
  support_guide: "คู่มือผู้ใช้",
  support_guide_desc: "คำแนะนำการใช้งานโดยละเอียดและแนวทางการบำรุงรักษา",

  // FAQ
  faq_title: "คำถามที่พบบ่อย",
  faq_q1: "ฉันจะเลือกเครื่องดนตรีทองเหลืองที่เหมาะสมได้อย่างไร?",
  faq_a1: "เราแนะนำให้เลือกตามระดับการเล่น สไตล์ดนตรี และงบประมาณของคุณ ผู้เริ่มต้นสามารถเลือกผลิตภัณฑ์ระดับเริ่มต้น ในขณะที่นักแสดงมืออาชีพสามารถเลือกซีรีส์ระดับไฮเอนด์ ทีมบริการลูกค้าของเราสามารถให้คำแนะนำมืออาชีพได้",
  faq_q2: "ระยะเวลาการรับประกันคือเท่าไร?",
  faq_a2: "ผลิตภัณฑ์ของเรามาพร้อมกับการรับประกันหนึ่งปี ปัญหาคุณภาพภายใต้การใช้งานปกติจะได้รับการซ่อมแซมหรือเปลี่ยนฟรี",
  faq_q3: "ฉันจะบำรุงรักษาเครื่องดนตรีทองเหลืองได้อย่างไร?",
  faq_a3: "เราแนะนำให้ทำความสะอาดภายในเครื่องดนตรีหลังการใช้งานแต่ละครั้ง เติมน้ำมันลิ้นและสไลด์เป็นประจำ หลีกเลี่ยงการชนและอุณหภูมิสุดขั้ว โปรดดูคู่มือผลิตภัณฑ์สำหรับแนวทางการบำรุงรักษาโดยละเอียด",
  faq_q4: "คุณมีบริการจัดส่งระหว่างประเทศหรือไม่?",
  faq_a4: "ใช่ ผลิตภัณฑ์ของเราจำหน่ายในหลายประเทศและภูมิภาคทั่วโลก โปรดติดต่อทีมขายของเราสำหรับวิธีการจัดส่งและค่าใช้จ่ายเฉพาะ",

  // Contact Section
  contact_title: "ติดต่อเรา",
  contact_subtitle: "เรารอคอยที่จะได้ยินจากคุณ",
  contact_info: "ข้อมูลติดต่อ",
  contact_address: "ที่อยู่",
  contact_address_value: "มณฑลซานตง จีน",
  contact_phone: "โทรศัพท์",
  contact_phone_value: "+65 91791835",
  contact_whatsapp: "WhatsApp",
  contact_whatsapp_value: "+65 91791835",
  contact_whatsapp_button: "แชทบน WhatsApp",
  contact_email: "อีเมล",
  contact_email_value: "โปรดฝากข้อความผ่านแบบฟอร์ม เราจะตอบกลับโดยเร็วที่สุด",
  contact_hours: "เวลาทำการ",
  contact_hours_value: "จันทร์ถึงศุกร์ 9:00-18:00",
  contact_form_title: "ฝากข้อความ",
  contact_form_name: "ชื่อ",
  contact_form_email: "อีเมล",
  contact_form_phone: "โทรศัพท์",
  contact_form_message: "ข้อความ",
  contact_form_submit: "ส่ง",
  contact_form_name_placeholder: "โปรดใส่ชื่อของคุณ",
  contact_form_email_placeholder: "โปรดใส่อีเมลของคุณ",
  contact_form_phone_placeholder: "โปรดใส่หมายเลขโทรศัพท์ของคุณ",
  contact_form_message_placeholder: "โปรดใส่ข้อความของคุณ (สูงสุด 500 ตัวอักษร)",
  contact_form_required: "จำเป็น",
  contact_form_success: "ส่งสำเร็จ! เราจะติดต่อคุณเร็วๆ นี้",
  contact_form_error: "การส่งล้มเหลว โปรดลองอีกครั้งในภายหลัง",
  contact_form_validate_required: "โปรดกรอกข้อมูลในช่องที่จำเป็นทั้งหมด",
  contact_form_validate_email: "โปรดใส่ที่อยู่อีเมลที่ถูกต้อง",
  contact_form_validate_message: "ข้อความต้องไม่เกิน 500 ตัวอักษร",

  // Footer
  footer_description: "มุ่งมั่นในการผลิตเครื่องดนตรีทองเหลืองคุณภาพสูง ให้ผลิตภัณฑ์ที่ยอดเยี่ยมสำหรับผู้รักดนตรีและนักแสดงมืออาชีพ",
  footer_quick_links: "ลิงก์ด่วน",
  footer_contact_us: "ติดต่อเรา",
  footer_address: "ที่อยู่: มณฑลซานตง จีน",
  footer_hours: "เวลาทำการ: จันทร์ถึงศุกร์ 9:00-18:00",
  footer_copyright: "สงวนลิขสิทธิ์",
  footer_powered: "ขับเคลื่อนโดย Readdy"
};
